import React from 'react';
import Spinner from './Spinner';

export default () => {
  return <div className='mt4'>
    <Spinner />
  </div>;
};
